import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

export const CompaniesContext = createContext();

const no_selected_company = {
	id: "",
	name: "",
	country: "",
	address: "",
	is_associated_company: true,
	description: "",
	database_id: "",
	tid: "",
	accounting_resources: {
		diaries: [],
		accounting_plan: [],
		expense_accounts: [],
		sale_accounts: [],
		others:{
			analytic_accounts:[]
		}
	},
	tax_authority_specifications: {
		pequenio_contribuyente: false,
	},
	database:{
		name:"",
		system:"",
		version:""
	}
};

export const CompaniesProvider = ({children}) => {
	const [companies, setCompanies] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState(no_selected_company);
	const [classification, setClassification] = useState({});

	useEffect(() => {
		if (selectedCompany) {
			setClassification(selectedCompany.treasury_resources?.classification || {});
		}
	}, [selectedCompany]);	

	const updateCompaniesIncludingLocalStorage = (value) => {
		localStorage.setItem("companies", JSON.stringify(value));
		setCompanies(value);
	};

	return (
		<CompaniesContext.Provider value={{
			companies, 
			setCompanies, 
			updateCompaniesIncludingLocalStorage,
			selectedCompany, 
			setSelectedCompany,
			classification,
			setClassification,
		}}>
			{children}
		</CompaniesContext.Provider>
	);
};

CompaniesProvider.propTypes = {
	children: PropTypes.node.isRequired,
};